import { fromJS } from 'immutable'
import {
  SHOW_MANUAL_USER,
  CLOSE_MANUAL_USER,
} from '../../constants'

const init = fromJS({
  isFetching: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case SHOW_MANUAL_USER:
      return state
        .set('isFetching', true)
        .set('isOpen', true)
    case CLOSE_MANUAL_USER:
      return state
        .set('isFetching', false)
        .set('isOpen', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/employee/employee-manual-reducer.js